import React from "react";

function SvgIcMapPoi006(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M26.907 16.917a1 1 0 00-1-1h-3.79l-2.183-4h2.973a1 1 0 000-2h-14a1 1 0 000 2h9.027l2.182 4h-8.378l2.183-3.98h-2l-2.183 3.98H5.907a1 1 0 000 2H8.64l-2.734 4.986h2l2.734-4.986h10.567l2.72 4.986h2l-2.72-4.986h2.7a1 1 0 001-1"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi006;
